import React from 'react';
import PropertyCard from './PropertyCard';

const PropertyGridView = ({
    properties,
    getDaysOnMarket,
    basePath = '/property',
    onEdit,
    onDelete
}) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {properties?.map((property) => {
                const daysOnMarket = getDaysOnMarket(property.created_at);

                return (
                    <PropertyCard
                        key={property.id}
                        property={property}
                        daysOnMarket={daysOnMarket}
                        basePath={basePath}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                );
            })}
        </div>
    );
};


export default PropertyGridView;
